export function formataData(dataStr: string): string {
    // Tenta criar um novo objeto Date
    const data = new Date(dataStr);

    // Verifica se a data é válida
    if (isNaN(data.getTime())) {
        throw new Error("Data inválida");
    }

    const dia = String(data.getUTCDate()).padStart(2, '0');  // Usar getUTCDate() para evitar problemas de fuso horário
    const mes = String(data.getUTCMonth() + 1).padStart(2, '0');  // Meses são indexados de 0 a 11
    const ano = data.getUTCFullYear();

    return `${dia}/${mes}/${ano}`;
}

export function formatarNumeroBR(numero: number, casasDecimais: number = 2) {
    return numero.toLocaleString('pt-BR', { minimumFractionDigits: casasDecimais, maximumFractionDigits: casasDecimais });
}
